
// export const myMutation = ( state ) => {

// }
export const setProgram = ( state, program ) => {
    state.program = program
}


export const setReport = ( state, report ) => {
    console.log(report);
    state.report = report
}